import { createContext, useContext, useState, useEffect } from 'react';
import AuthService from '../services/auth.service';
import toast from 'react-hot-toast';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        checkUser();
    }, []);

    const checkUser = async () => {
        try {

            const token = localStorage.getItem('access_token');
            if (token) {
                const response = await AuthService.getCurrentUser();
                setUser(response.data);
            }
        } catch (error) {
            console.error('Session has expired expired or invalid');
            AuthService.logout();
        } finally {
            setLoading(false);
        }
    };

    const login = async (email, password) => {
        try {
            const response = await AuthService.login(email, password);
            if (response.user) {
                setUser(response.user);
            } else {
                await checkUser();
            }
            toast.success('Logged in successfully');
            return true;
        } catch (error) {
            console.error(error);
            toast.error('Invalid credentials');
            return false;
        }
    };

    const register = async (data) => {
        try {
            await AuthService.register(data);
            toast.success('Registration successful. Please login.');
            return true;
        } catch (error) {
            console.error(error);
            const msg = error.response?.data?.email?.[0] || 'Registration failed';
            toast.error(msg);
            return false;
        }
    };

    const logout = () => {
        AuthService.logout();
        setUser(null);
        toast.success('Logged out');
        window.location.href = '/login';
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
